import React from "react";
import { Button } from "@/components/ui/button";
import { CalendarIcon } from "lucide-react";
import { format } from "date-fns";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import useTripCreation from "@/stores/new-trip/useNewTrip";

const DepartureDateStep: React.FC = () => {
  const {
    leavingFrom,
    leavingDate,
    isDatePopoverOpen,
    setDatePopoverOpen,
    setLeavingDate,
  } = useTripCreation();

  const title = leavingFrom
    ? `When are you leaving ${leavingFrom.name}?`
    : "When are you leaving?";

  return (
    <div className="z-20 space-y-8">
      <h2 className="text-2xl font-medium text-indigo-950 text-center">
        {title}
      </h2>
      <div className="flex justify-center">
        <Popover open={isDatePopoverOpen} onOpenChange={setDatePopoverOpen}>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className="w-full justify-center text-center rounded-2xl py-6 bg-white shadow-sm border border-gray-200 hover:border-indigo-400 hover:shadow-md transition-all duration-200"
            >
              <CalendarIcon className="mr-2 h-6 w-6 text-indigo-600" />
              {leavingDate ? (
                <span className="text-indigo-950 font-normal text-base">
                  {format(leavingDate, "PPP")}
                </span>
              ) : (
                <span className="text-neutral-500 font-normal text-base">
                  Pick your departure date
                </span>
              )}
            </Button>
          </PopoverTrigger>
          <PopoverContent
            className="w-auto p-0 bg-white shadow-lg border border-indigo-100 rounded-2xl"
            align="center"
            side="bottom"
          >
            <Calendar
              mode="single"
              selected={leavingDate || undefined}
              onSelect={(date) => setLeavingDate(date || null)}
              initialFocus
              fromDate={new Date()}
              className="rounded-2xl"
            />
          </PopoverContent>
        </Popover>
      </div>
    </div>
  );
};

export default DepartureDateStep;
